<div class="dialog-content-max">
    <form [formGroup]="OrganisationForm">
        <div class="formgrid grid">
            <div class="field col-6">
                <label for="orgname" class="required-label">Organisation Name<span class="maxchars">(Max 100
                        chars)</span><span>*</span></label>
                <input type="text" class="form-control" id="orgname" placeholder="Enter Organisation Name"
                    name="orgname" formControlName="orgname" readonly>
            </div>
        </div>        
        <div class="formgrid grid">
            <div class="field col-6">
                <label for="noofcompany">No. of Entity <span class="maxchars">(Max 6 Digits)</span>
                    <span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>
                </label>
                <input type="text" class="form-control" id="noofcompany" placeholder="Enter No of entity"
                    name="noofcompany" formControlName="noofcompany" (keypress)="utilityservice.onlyNumberKey($event)">
                <span style="color:red"
                    *ngIf="OrganisationForm.get('noofcompany').invalid && (OrganisationForm.get('noofcompany').touched || OrganisationForm.get('noofcompany').dirty)">
                    {{getErrorMessage(OrganisationForm,validation_message,'noofcompany')}}
                </span>
            </div>
            <div class="field col-6">
                <label for="noofuser">No. of User <span class="maxchars">(Max 5 Digits)</span><span
                        style="color: rgb(222, 30, 30); font-weight: bold;">*</span> </label>
                <input type="text" class="form-control" id="noofuser" placeholder="Enter No of user" name="noofuser"
                    formControlName="noofuser" (keypress)="utilityservice.onlyNumberKey($event)">
                <span style="color:red"
                    *ngIf="OrganisationForm.get('noofuser').invalid && (OrganisationForm.get('noofuser').touched || OrganisationForm.get('noofuser').dirty)">
                    {{getErrorMessage(OrganisationForm,validation_message,'noofuser')}}
                </span>
            </div>
        </div>
        <div class="formgrid grid">
            <div class="field col-6">
                <label for="nooflocation">No. Of Location <span class="maxchars">(Max 5 Digits)</span>
                    <span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>
                </label>
                <input type="text" class="form-control" id="nooflocation" placeholder="Enter No of location"
                    name="nooflocation" formControlName="nooflocation"
                    (keypress)="utilityservice.onlyNumberKey($event)">
                <span style="color:red"
                    *ngIf="OrganisationForm.get('nooflocation').invalid && (OrganisationForm.get('nooflocation').touched || OrganisationForm.get('nooflocation').dirty) ">
                    {{getErrorMessage(OrganisationForm,validation_message,'nooflocation')}}
                </span>
            </div>
            <div class="field col-6">
                <label for="spaceallowed">Space Allowed(in GB) <span class="maxchars">(Max 5 digits)</span><span
                        style="color: rgb(222, 30, 30); font-weight: bold;">*</span> </label>
                <input type="text" class="form-control" id="spaceallowed" placeholder="Enter Space allowed"
                    name="spaceallowed" formControlName="spaceallowed"
                    (keypress)="utilityservice.onlyNumberKey($event)">
                <span style="color:red"
                    *ngIf="OrganisationForm.get('spaceallowed').invalid && (OrganisationForm.get('spaceallowed').touched || OrganisationForm.get('spaceallowed').dirty) ">
                    {{getErrorMessage(OrganisationForm,validation_message,'spaceallowed')}}
                </span>
            </div>
        </div>
        <div class="formgrid grid">
            <div class="field col-6">
                <label for="nooftraining">No. of Training<span class="maxchars">(Max 5 Digits)</span>
                    <span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>
                </label>
                <input type="text" class="form-control" id="nooftraining" placeholder="Enter no of Training"
                    name="nooftraining" formControlName="nooftraining"
                    (keypress)="utilityservice.onlyNumberKey($event)">
                <span style="color:red"
                    *ngIf="OrganisationForm.get('nooftraining').invalid && (OrganisationForm.get('nooftraining').touched || OrganisationForm.get('nooftraining').dirty) ">
                    {{getErrorMessage(OrganisationForm,validation_message,'nooftraining')}}
                </span>
            </div>
            <div class="field col-4">
                <label for="issuspended">Is Suspended<span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>
                </label>
                <p-dropdown [showClear]="true" pTooltip="Select Org type" [options]="yesnolist" placeholder="Select"
                    optionLabel="label" optionValue="value" styleClass="fixed-width-dropdown-filter" name="issuspended"
                    id="issuspended" appendTo="body" formControlName="issuspended"></p-dropdown>
                <span style="color:red"
                    *ngIf="OrganisationForm.get('issuspended').invalid && (OrganisationForm.get('issuspended').touched || OrganisationForm.get('issuspended').dirty)">
                    {{getErrorMessage(OrganisationForm,validation_message,'issuspended')}}
                </span>
            </div>
        </div>
        <div class="formgrid grid">
            <div class="field col-4">
                <label for="requirebusinessuser">Is Business user required
                    <span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>
                </label>
                <p-dropdown [showClear]="true" pTooltip="Select Org type" [options]="yesnolist" placeholder="Select"
                    optionLabel="label" optionValue="value" styleClass="fixed-width-dropdown-filter"
                    name="requirebusinessuser" id="requirebusinessuser" appendTo="body"
                    formControlName="requirebusinessuser"></p-dropdown>
                <span style="color:red"
                     *ngIf="OrganisationForm.get('requirebusinessuser').invalid && (OrganisationForm.get('requirebusinessuser').touched || OrganisationForm.get('requirebusinessuser').dirty) ">
                    {{getErrorMessage(OrganisationForm,validation_message,'requirebusinessuser')}}
                </span>
            </div>
            <div class="field col-4" *ngIf="OrganisationForm.get('requirebusinessuser').value=='Y'">
                <label for="noofbuser">No. Business User <span class="maxchars">(Max 5 Digits)</span>
                    <span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>
                </label>
                <input type="text" class="form-control" placeholder="Enter No of Business User" name="noofbuser"
                    id="noofbuser" formControlName="noofbuser" (keypress)="utilityservice.onlyNumberKey($event)">
                <span style="color:red"
                    *ngIf="OrganisationForm.get('noofbuser').invalid && (OrganisationForm.get('noofbuser').touched || OrganisationForm.get('noofbuser').dirty) ">
                    {{getErrorMessage(OrganisationForm,validation_message,'noofbuser')}}
                </span>
            </div>
        </div>

        <div class="grid">
            <div class="field col-4">
                <label for="databackupdownloadflag">Data Backup<span
                        style="color: rgb(222, 30, 30); font-weight: bold;">*</span> </label>
                <p-dropdown [showClear]="true" pTooltip="Select Org type" [options]="yesnolist" placeholder="Select"
                    optionLabel="label" optionValue="value" styleClass="fixed-width-dropdown-filter"
                    name="databackupdownloadflag" id="databackupdownloadflag" appendTo="body"
                    formControlName="databackupdownloadflag"></p-dropdown>
                <span style="color:red"
                    *ngIf="OrganisationForm.get('databackupdownloadflag').invalid && (OrganisationForm.get('databackupdownloadflag').touched || OrganisationForm.get('databackupdownloadflag').dirty) ">
                    {{getErrorMessage(OrganisationForm,validation_message,'databackupdownloadflag')}}
                </span>
            </div>
        </div>
    </form>
</div>

<div class="custom-dialog-footer">
    <p-button class="m-1" label="Close" styleClass="customeclose"
        (click)="closemodal(OrganisationForm,this.ref,'Are you sure you want to close?')"></p-button>
    <p-button class="m-1" label="{{saveTitle}}" (click)="modifyBd()"  styleClass="customesave"></p-button>
</div>